<template>
  <div>
    <h1>{{ journeyName }}</h1>
    <p>旅行总金额: {{ totalAmount }}</p>
    <p v-for="(transfer, index) in transferAmounts" :key="index">{{ transfer }}</p>
    <button @click="showAddModal = true">新增账务</button>
    <table>
      <thead>
        <tr>
          <th>日期</th>
          <th>类别</th>
          <th>项目</th>
          <th>付款人</th>
          <th v-for="member in members" :key="member.memberId">{{ member.memberName }} 分摊金额</th>
          <th>备注</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="account in accounts" :key="account.id">
          <td>{{ account.date }}</td>
          <td>{{ account.category }}</td>
          <td>{{ account.item }}</td>
          <td>{{ getMemberName(account.payerId) }}</td>
          <td v-for="member in members" :key="member.memberId">{{ getShareAmount(account.id, member.memberId) }}</td>
          <td>{{ account.remark }}</td>
          <td>
            <button @click="editAccount(account)">编辑</button>
            <button @click="deleteAccount(account.id)">删除</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="showAddModal" class="modal">
      <div class="modal-content">
        <h2>{{ editAccountId? '修改账务' : '新增账务' }}</h2>
        <label for="date">日期:</label>
        <DatePicker
          v-model="newAccount.date"
          type="date"
          :picker-options="{
            shortcuts: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd'
          }"
          placeholder="选择日期"
        />
        <label for="payer">付款人:</label>
        <select v-model="newAccount.payerId" id="payer">
          <option v-for="member in members" :key="member.memberId" :value="member.memberId">{{ member.memberName }}</option>
        </select>
        <label for="totalAmount">总金额:</label>
        <input type="number" step="0.01" v-model="newAccount.totalAmt" id="totalAmount" @input="calculateShares">
        <label for="isAverage">是否平均:</label>
        <input type="checkbox" v-model="isAverage" id="isAverage" @change="calculateShares">
        <div v-for="member in members" :key="member.memberId">
          <label :for="'share-' + member.memberId">{{ member.memberName }} 分摊金额:</label>
          <input type="number" step="0.01" :id="'share-' + member.memberId" :disabled="isAverage" v-model="newAccount.shares[member.memberId]" @input="validateShares">
        </div>
        <label for="remark">备注:</label>
        <input type="text" v-model="newAccount.remark" id="remark">
        <button @click="submitAccount">提交</button>
        <button @click="showAddModal = false">取消</button>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    data() {
      return {
        journeyId: '',
        journeyName: '',
        members: [],
        accounts: [],
        showAddModal: false,
        editAccountId: null,
        newAccount: {
          id: null,
          journeyId: null,
          date: '',
          category: '',
          item: '',
          payerId: null,
          totalAmt: 0,
          shares: {},
          remark: ''
        },
        isAverage: false
      };
    },
    computed: {
      totalAmount() {
        return this.accounts.reduce((sum, account) => sum + parseFloat(account.totalAmt), 0).toFixed(2);
      },
      transferAmounts() {
        const transfers = {};
        this.accounts.forEach(account => {
          const payer = this.getMemberName(account.payerId);
          Object.keys(account.shares).forEach(memberId => {
            const share = parseFloat(account.shares[memberId]);
            const member = this.getMemberName(memberId);
            if (memberId !== account.payerId) {
              if (!transfers[`${member} -> ${payer}`]) {
                transfers[`${member} -> ${payer}`] = 0;
              }
              transfers[`${member} -> ${payer}`] += share;
            }
          });
        });
        return Object.keys(transfers).map(key => `${key} ${transfers[key].toFixed(2)}元`);
      }
    },
    mounted() {
      const urlParams = new URLSearchParams(window.location.search);
      this.journeyId = urlParams.get('journeyId');
      this.fetchTravelInfo();
    },
    methods: {
      fetchTravelInfo() {
        fetch(`/api/travel_info.php?journeyId=${this.journeyId}`)
          .then(response => response.json())
          .then(data => {
            this.journeyName = data.journey.journeyName;
            this.members = data.members;
            this.accounts = data.accounts;
            this.members.forEach(member => {
              this.newAccount.shares[member.memberId] = 0;
            });
          });
      },
      getMemberName(memberId) {
        const member = this.members.find(m => m.memberId === memberId);
        return member ? member.memberName : '';
      },
      getShareAmount(accountId, memberId) {
        const account = this.accounts.find(a => a.id === accountId);
        return account ? account.shares[memberId] : 0;
      },
      editAccount(account) {
        this.editAccountId = account.id;
        this.newAccount = { ...account };
        this.showAddModal = true;
      },
      deleteAccount(accountId) {
        if (confirm('确定要删除这条账务吗？')) {
          fetch(`/api/account.php?id=${accountId}&is_delete=1`, {
            method: 'PUT'
          })
            .then(response => response.json())
            .then(() => {
              this.accounts = this.accounts.filter(a => a.id !== accountId);
            });
        }
      },
      calculateShares() {
        if (this.isAverage) {
          const share = (parseFloat(this.newAccount.totalAmt) / this.members.length).toFixed(2);
          this.members.forEach(member => {
            this.newAccount.shares[member.memberId] = share;
          });
        }
      },
      validateShares() {
        if (!this.isAverage) {
          const sum = Object.values(this.newAccount.shares).reduce((acc, val) => acc + parseFloat(val), 0);
          if (sum > parseFloat(this.newAccount.totalAmt)) {
            const lastMemberId = this.members[this.members.length - 1].memberId;
            this.newAccount.shares[lastMemberId] = (parseFloat(this.newAccount.totalAmt) - (sum - parseFloat(this.newAccount.shares[lastMemberId]))).toFixed(2);
          }
        }
      },
      submitAccount() {
        const data = {
          ...this.newAccount,
          journeyId: this.journeyId
        };
        const method = this.editAccountId ? 'PUT' : 'POST';
        fetch('/api/account.php', {
          method,
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
          .then(response => response.json())
          .then(() => {
            this.showAddModal = false;
            this.editAccountId = null;
            this.newAccount = {
              id: null,
              journeyId: null,
              date: '',
              category: '',
              item: '',
              payerId: null,
              totalAmt: 0,
              shares: {},
              remark: ''
            };
            this.members.forEach(member => {
              this.newAccount.shares[member.memberId] = 0;
            });
            this.fetchTravelInfo();
          });
      }
    }
  };
  </script>
  
  <style scoped>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
  }
  </style>